export const identity = (item: any) => item
export const nothing = () => { }
export const inputValue = (e: any) => e.target.value  